import Section from 'components/Section'
import { Typography, MediaImageStandard } from 'components/Contentful'
import { AchieveTheme, Grid } from '@achieve/ascend'
import { Carousel } from 'components/Carousels'
import styles from './FlatCarousel.module.scss'
import classNames from 'classnames'

function Card({ item: { cardImage, cardTitleText, cardText }, priority }) {
  const textList = cardText?.json?.content ?? []
  const quote = textList?.[0]?.content ? { json: textList[0], links: cardText.links } : ''
  const attribution = textList?.[1]?.content ? { json: textList[1], links: cardText.links } : ''

  return (
    <Grid
      container
      direction={{ xs: 'column-reverse', lg: 'row' }}
      justifyContent={{ xs: 'flex-end', lg: 'space-between' }}
      alignItems={{ xs: 'center', lg: 'flex-start' }}
    >
      <Grid item xs={12} lg={4}>
        <div className={styles['image-container']}>
          <MediaImageStandard content={cardImage} priority={priority} />
        </div>
      </Grid>
      <Grid item xs={12} lg={7}>
        <Grid container direction="column" className={styles['card-text-grid']}>
          <Grid item xs={12}>
            <Typography
              className={classNames(
                styles['carousel-item-title'],
                'displayMd lg:displayLg font-bold'
              )}
              content={cardTitleText}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography
              className={classNames(
                styles['carousel-item-quote'],
                'displaySm lg:displayMd font-medium'
              )}
              content={quote}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography content={attribution} className="bodyXs lg:headingMd font-light" />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

function FlatCarousel({ carouselItems, idPrefix = 'page' }) {
  // If the image is nested in a scrollable parent element other than the root document,
  // you will also need to assign the lazyRoot prop
  // https://nextjs.org/docs/api-reference/next/image#lazyroot
  // https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/root

  return (
    <Section
      backgroundColor={AchieveTheme?.ascend?.colors?.blue[500]}
      className={styles['section']}
      contain={false}
    >
      <Carousel
        className={styles['flat-carousel-wrapper']}
        carouselItems={carouselItems}
        itemComponent={Card}
        variant="standard"
        idPrefix={`${idPrefix}-testimonial-carousel`}
        classNameIndicatorDots={styles['flat-carousel-indicators']}
        withIndicators
      />
    </Section>
  )
}

export { FlatCarousel }
